import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const EarningIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 17.596 17.596' className={className}>
    <path id="Path_13143" data-name="Path 13143" fill="#3e4552" d="M4.8,6.192H16.326c2.01,0,3.035-1.015,3.035-3v-11.6c0-1.98-1.025-2.995-3.035-2.995H4.8c-2.01,0-3.035,1-3.035,2.995v11.6C1.765,5.177,2.79,6.192,4.8,6.192Zm5.758-4.08a.858.858,0,0,1-.864-.965V-1.747H6.649A.859.859,0,0,1,5.674-2.6a.861.861,0,0,1,.975-.884H9.694V-6.55a.853.853,0,0,1,.864-.965.862.862,0,0,1,.884.965v3.065H14.5a.856.856,0,0,1,.975.884c0,.543-.392.854-.975.854H11.443V1.148A.862.862,0,0,1,10.558,2.112Z" transform="translate(-1.765 11.404)"/>
  </SvgIcon>
);

export default EarningIcon;
